import { WideLayout } from '../../../../shared/layout/widelayout';
import { Spinner } from '../../../../shared/ui/Spinners';
import { useOrderFlowStore } from '../../store/newOrderFlowStore';
import { ConfigureEquipment } from './configureEquipment';
import { BasketFlowScreen } from './configureEquipmentMockup';
import { useApiQuestionnaire } from './configureEquipmentMockup/basketApi';

/**
 * "Gerando seu pedido": usa o fluxo novo quando GET /basket/<id do produto>
 * devolve um questionário; com `null` (ou erro) segue no fluxo atual.
 */
export const ConfigureEquipmentRouter = () => {
  const product = useOrderFlowStore((state) => state.selectedSubCategory);
  const parsedProductSapCode = Number(product?.sap_code);
  const productSapCode =
    Number.isFinite(parsedProductSapCode) && parsedProductSapCode > 0
      ? parsedProductSapCode
      : undefined;
  const flow = useApiQuestionnaire(productSapCode);

  if (productSapCode !== undefined && flow.status === 'done' && flow.data) {
    return (
      <WideLayout
        outlet={
          <BasketFlowScreen
            flow={flow.data}
            productId={product.id}
            product={product}
          />
        }
      />
    );
  }

  // Aqui "done" é a resposta null: produto ainda sem fluxo novo.
  if (
    productSapCode === undefined ||
    flow.status === 'done' ||
    flow.status === 'error'
  ) {
    if (flow.status === 'error') {
      console.warn('[configureEquipment] fluxo novo indisponível:', flow.error);
    }
    return <ConfigureEquipment />;
  }

  return (
    <WideLayout
      outlet={
        <div
          style={{
            width: '100%',
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner />
        </div>
      }
    />
  );
};
